import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsFeedLazy = loadable(() => import(/* webpackChunkName: "SettingsFeed" */ './SettingsFeedSuspense'));

export const SettingsFeedAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsFeedLazy />
    </DelayedSuspense>
);
